// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

import { css } from '@emotion/css';
import { Theme, useTheme } from '@mui/material';

import { useTimeline } from '@components/Timeline/Timeline/TimelineProvider';

import TimelineAreaRow from '@components/Timeline/Timeline/TimelineAreaRow';
import TimelineAreaMarker from '@components/Timeline/Timeline/TimelineAreaMarker';
import TimelineAreaMarkerCurrent from '@components/Timeline/Timeline/TimelineAreaMarkerCurrent';
import TimelineAreaMarkerHover from '@components/Timeline/Timeline/TimelineAreaMarkerHover';

// COMPONENT ---------------------------------------------------------------- //

const TimelineAreaBody = () => {
  const theme = useTheme();
  const cls = useStyles(theme);

  const { data, isCurrentDay, isHovering, markerHoverPosition, markerHoverTime, markers, showMarkers, zIndex } =
    useTimeline();

  if (!data?.length) return null;
  return (
    <div className={cls.timelineAreaBody} style={{ zIndex: zIndex + 1 }}>
      {data?.map((dataItem, i) => (
        <React.Fragment key={`timeline-area-row-${dataItem?.id || i}`}>
          <TimelineAreaRow dataItem={dataItem} index={i} isLastItem={i === data?.length - 1} />
        </React.Fragment>
      ))}

      {showMarkers ? (
        <>
          {isCurrentDay ? <TimelineAreaMarkerCurrent showLabel={false} /> : null}

          {markers?.map((marker, i) => (
            <TimelineAreaMarker key={`timeline-area-marker-${i}`} showLabel={false} marker={marker} />
          ))}

          {isHovering && markerHoverPosition && markerHoverTime ? <TimelineAreaMarkerHover showLabel={false} /> : null}
        </>
      ) : null}
    </div>
  );
};

// STYLES --------------------------------------------------------------------- //

const useStyles = (theme: Theme) => ({
  timelineAreaBody: css`
    position: relative;
    flex: 1;
    width: 100%;
    background-color: ${theme.palette.background.paper};
    box-shadow: 0 0 16px #00000024;
  `,
});

// -------------------------------- EXPORT -------------------------------- //

export default TimelineAreaBody;
